import React from "react";
export var Step = function (props) {
    var classNames = "mdl-stepper-step";
    if (props.done) {
        classNames += " step-done";
    }
    if (props.active) {
        classNames += " active-step";
    }
    return (React.createElement("div", { className: classNames },
        React.createElement("div", { className: "mdl-stepper-circle" },
            React.createElement("span", null, props.stepNumber)),
        React.createElement("div", { className: "mdl-stepper-title" }, props.children),
        React.createElement("div", { className: "mdl-stepper-bar-left" }),
        React.createElement("div", { className: "mdl-stepper-bar-right" })));
};
